var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('spinner',{attrs:{"size":_vm.size,"spacing":40,"message":"","line-fg-color":_vm.$primaryColor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }